import React from 'react';
import { AlertTriangle, AlertCircle, Info, CheckCircle2 } from 'lucide-react';

const URGENCY_CONFIG = {
  high:     { icon: AlertTriangle, color: 'border-rose-200 bg-rose-50',     badge: 'bg-rose-100 text-rose-700',     label: 'High Priority',   iconColor: 'text-rose-500',    scoreColor: 'text-rose-600',    listLabel: 'Key Issues' },
  medium:   { icon: AlertCircle,   color: 'border-amber-200 bg-amber-50',   badge: 'bg-amber-100 text-amber-700',   label: 'Medium Priority', iconColor: 'text-amber-500',   scoreColor: 'text-rose-600',    listLabel: 'Key Issues' },
  low:      { icon: Info,          color: 'border-blue-200 bg-blue-50',     badge: 'bg-blue-100 text-blue-700',     label: 'Low Priority',    iconColor: 'text-blue-500',    scoreColor: 'text-amber-600',   listLabel: 'Key Issues' },
  on_track: { icon: CheckCircle2,  color: 'border-emerald-200 bg-emerald-50', badge: 'bg-emerald-100 text-emerald-700', label: 'Doing Well',     iconColor: 'text-emerald-500', scoreColor: 'text-emerald-600', listLabel: 'Recent Wins' },
};

const StatTile = ({ label, value, valueColor }) => (
  <div className="bg-white rounded-lg py-2">
    <p className="text-xs text-slate-400">{label}</p>
    <p className={`font-bold ${valueColor}`}>{value}</p>
  </div>
);

export const AgentCoachingCard = ({ agent, onAgentClick }) => {
  const cfg = URGENCY_CONFIG[agent.urgency] || URGENCY_CONFIG.low;
  const Icon = cfg.icon;
  const clickable = !!onAgentClick;

  return (
    <div
      className={`rounded-xl border p-4 ${cfg.color} ${clickable ? 'cursor-pointer hover:opacity-90 transition-opacity' : ''}`}
      onClick={() => clickable && onAgentClick(agent.agent_id)}
      data-testid={`coaching-card-${agent.agent_id}`}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-full bg-white flex items-center justify-center shadow-sm font-bold text-slate-700">
            {agent.agent_name.charAt(0)}
          </div>
          <div>
            <p className="font-semibold text-slate-900">{agent.agent_name}</p>
            <p className="text-xs text-slate-500">{agent.call_type}</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${cfg.badge}`}>{cfg.label}</span>
          <Icon className={`w-4 h-4 ${cfg.iconColor}`} />
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2 mb-3 text-center">
        <StatTile label="Avg Score" value={agent.avg_score} valueColor={cfg.scoreColor} />
        <StatTile label="Total Calls" value={agent.total_calls} valueColor="text-slate-700" />
        <StatTile label="Escalated" value={agent.escalated_calls ?? 0} valueColor="text-amber-600" />
      </div>

      {agent.top_issues.length > 0 && (
        <div>
          <p className="text-xs font-medium text-slate-600 mb-1">{cfg.listLabel}:</p>
          <ul className="space-y-1">
            {agent.top_issues.map((issue, i) => (
              <li key={`issue-${i}`} className="text-xs text-slate-600 flex items-start gap-1">
                <span className="mt-0.5 text-slate-400">•</span> {issue}
              </li>
            ))}
          </ul>
        </div>
      )}
      {clickable && <p className="text-xs text-slate-400 mt-3 text-right">View calls →</p>}
    </div>
  );
};
